import { api, reportStorageUrl } from '@/http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { extension as getMimeExtension } from 'mime-types';
import sanitizeFilename from 'sanitize-filename';

function getExtensionFromFile(file: File): string {
  if (file.type) {
    const extension = getMimeExtension(file.type);
    if (extension) {
      return extension;
    }
  }

  const rawName = file.name.trim();
  const fileExtension = rawName.split('.').pop();
  if (fileExtension && fileExtension !== rawName) {
    return fileExtension.toLowerCase();
  }

  throw new Error('Could not determine image file extension');
}

/*
  TODO: good to move all this building filename to backend
 */
function buildUploadFileName(file: File): string {
  const rawName = file.name.trim();
  const dotIndex = rawName.lastIndexOf('.');
  const baseName = dotIndex > 0 ? rawName.slice(0, dotIndex) : rawName;
  const safeBaseName = sanitizeFilename(baseName) || 'image';
  const extension = getExtensionFromFile(file);

  return `${safeBaseName}-${crypto.randomUUID()}.${extension}`;
}

export function useUploadFiles(folder: string) {
  return async (file: File): Promise<string> => {
    const formData = new FormData();
    const fileName = buildUploadFileName(file);

    formData.append('file', file, fileName);
    formData.append('fileName', fileName);
    formData.append('folder', folder);
    formData.append('allowDuplicate', 'true');

    const response = await fetchWrapper.post<{ filePath?: string }>(
      api.orgFiles,
      formData,
      undefined,
      null,
    );
    const filePath = response.filePath;

    if (!filePath) {
      throw new Error('Missing uploaded file path');
    }

    return `${reportStorageUrl}${filePath}`;
  };
}
